// Short labels for the key names key-util.js produces ("LEFT", "A", "SPACE",
// "NUM4"...), for the small key chips that mark a keyboard player's row.
const LABELS: Record<string, string> = {
  LEFT: "←", RIGHT: "→", UP: "↑", DOWN: "↓",
  SPACE: "SPC", ENTER: "↵", TAB: "TAB", SHIFT: "SHFT", "L-SHIFT": "SHFT", "R-SHIFT": "SHFT",
  "L-CTRL": "CTRL", "R-CTRL": "CTRL", "L-ALT": "ALT", "R-ALT": "ALT", "L-COM": "CMD", "R-COM": "CMD",
  BACK: "⌫", DELETE: "DEL", ESC: "ESC", CAPS: "CAPS",
};

export function keyLabel(key: string | null | undefined): string {
  if (!key) return "?";
  return LABELS[key] || key;
}
